import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { about } from '../content/portfolio';
import Reveal from './Reveal';

const About: React.FC = () => {
  const { language } = useLanguage();
  const c = about[language];

  return (
    <section id="about" data-ink="#e8e6e1" data-field="#0c0b09" className="bg-code-bg py-24 text-code-text sm:py-32">
      <div className="container-responsive">
        <Reveal>
          <h2 className="font-serif text-4xl font-medium sm:text-5xl">
            {language === 'pt' ? 'Stack e formação' : 'Stack and background'}
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-x-12 gap-y-14 md:grid-cols-[minmax(0,15rem)_1fr] lg:grid-cols-[34%_1fr]">
          <Reveal>
            <dl className="space-y-6">
              {c.facts.map((f) => (
                <div key={f.label}>
                  <dt className="text-base text-code-comment">{f.label}</dt>
                  <dd className="mt-1 text-xl leading-snug">{f.value}</dd>
                </div>
              ))}
            </dl>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-[60ch] text-xl leading-[1.5]">
              {c.paragraph}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
